let lastCreatedId = 0;
export const makeRandomId = () => {
  lastCreatedId += 1;
  return `${Math.floor(Math.random() * 999999)}_${lastCreatedId}`;
};
